import { APIS } from '@constants/apis'
import { useCallback, useState } from 'react'
import useFetch from './useFetch'

const useGetProfileImage = () => {
  const [image, setImage] = useState()
  const { execute: _getDownLoadImage } = useFetch(
    APIS.FILES.GET_PROFILE_PICTURE_DOWNLOAD_URL
  )

  const getDownLoadImage = useCallback(
    ({ profilePicture, isTemp = false }) => {
      _getDownLoadImage(
        {
          payload: { profilePicture, isTemp }
        },
        {
          onSuccess: ({ data }) => setImage(data.url)
        }
      )
    },
    [_getDownLoadImage]
  )

  return { getDownLoadImage, image }
}

export default useGetProfileImage
